import { cva } from "class-variance-authority";

export const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-xs hover:bg-primary/80",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border border-error-foreground bg-error-light text-error-foreground",
        success:
          "border border-success-foreground bg-success-light text-success-foreground",
        warning:
          "border border-warning-foreground bg-warning-light text-warning-foreground",
        info: "border border-info-foreground bg-info-light text-info-foreground",
        outline: "text-foreground",
        "destructive-outline": "border-error-border text-error-foreground",
        "success-outline": "border-success-border text-success-foreground",
        "warning-outline": "border-warning-border text-warning-foreground",
        "info-outline": "border-info-border text-info-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);
